import {get, post, download} from "../api"
import * as url from "../url"

const apiGetDashboardFilesCount = data => {
  return get(url.API_STATS + "files-count/", data.history)
}

export {
  apiGetDashboardFilesCount,
}
